import {
  Links,
  Meta,
  Outlet,
  Scripts,
  ScrollRestoration,
  useLoaderData,
} from "@remix-run/react";
import * as Sentry from "@sentry/remix";
import { json, type LoaderFunctionArgs } from "@remix-run/node";

export const links = () => [
  { rel: "stylesheet", href: "/premium.css" },
];

export const loader = async ({ request }: LoaderFunctionArgs) => {
  return json({
    ENV: {
      SENTRY_DSN: process.env.SENTRY_DSN,
    },
  });
};


export default function App() {
  const { ENV } = useLoaderData<typeof loader>();

  return (

    <html>
      <head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width,initial-scale=1" />
        <link rel="preconnect" href="https://cdn.shopify.com/" />
        <link
          rel="stylesheet"
          href="https://cdn.shopify.com/static/fonts/inter/v4/styles.css"
        />
        <Meta />
        <Links />
        {/* Baseline CSS for FOUC Mitigation and Premium Launching Experience */}
        <style dangerouslySetInnerHTML={{ __html: `
          html, body {
            background-color: #f6f6f7;
            margin: 0;
            padding: 0;
            font-family: Inter, -apple-system, BlinkMacSystemFont, "San Francisco", "Segoe UI", Roboto, "Helvetica Neue", sans-serif;
            -webkit-font-smoothing: antialiased;
            overflow-x: hidden;
          }
          *, *::before, *::after { box-sizing: border-box; }
          img, video { max-width: 100%; }
          .app-gate {
            opacity: 0;
            transition: opacity 0.3s ease-out;
          }
          .app-gate-ready {
            opacity: 1 !important;
          }
          .Polaris-Page {
            max-width: var(--p-breakpoints-md-up, 1200px);
            margin: 0 auto;
          }
          @media (max-width: 767px) {
            .Polaris-Page, .Polaris-Layout, .Polaris-Box {
              min-width: 0 !important;
            }
          }
        `}} />

      </head>
      <body>
        <Outlet />
        <ScrollRestoration />
        <script
          dangerouslySetInnerHTML={{
            __html: `window.ENV = ${JSON.stringify(ENV)}`,
          }}
        />
        <Scripts />

      </body>
    </html>
  );
}

export const ErrorBoundary = Sentry.captureRemixErrorBoundaryError;

